<div class="profile-page">
  <ut-community-profile-header
    [user]="user"
    [me]="me()"
    [isOwn]="isOwn()"
    [testerAppUrl]="testerAppUrl()"
    [utestUrl]="utestUrl()"
    [followingCount]="followingCount()"></ut-community-profile-header>

  @if (section() === 'people') {
    <nav class="profile-page__people-nav" aria-label="Followers and following">
      <a class="ut-btn ut-btn--secondary ut-btn--sm" uiSref="profile.about" [uiParams]="{ profileId: user.slug }">
        <span class="material-icons" aria-hidden="true">arrow_back</span>
        Back to profile
      </a>
      <div class="profile-page__tabs profile-page__tabs--inline">
        <a class="profile-page__tab" [class.is-active]="child() === 'followers'" [attr.aria-current]="child() === 'followers' ? 'page' : null"
           uiSref="profile.followers" [uiParams]="{ profileId: user.slug }">Followers · {{ user.follow_stats.follower_count | number }}</a>
        <a class="profile-page__tab" [class.is-active]="child() === 'following'" [attr.aria-current]="child() === 'following' ? 'page' : null"
           uiSref="profile.following" [uiParams]="{ profileId: user.slug }">Following · {{ followingCount() | number }}</a>
      </div>
    </nav>
  } @else {
    <ut-view-picker class="profile-page__picker" [options]="views()" [value]="stateName()" (selected)="go($event)"></ut-view-picker>
    <nav class="profile-page__tabs" aria-label="Profile sections">
      <a class="profile-page__tab" [class.is-active]="section() === 'overview'" [attr.aria-current]="section() === 'overview' ? 'page' : null"
         uiSref="profile.about" [uiParams]="{ profileId: user.slug }">Overview</a>
      @for (tab of postTabs; track tab.value) {
        <a class="profile-page__tab" [class.is-active]="child() === tab.value" [attr.aria-current]="child() === tab.value ? 'page' : null"
           [uiSref]="tab.state" [uiParams]="{ profileId: user.slug }">{{ tab.label }}</a>
      }
      <a class="profile-page__tab" [class.is-active]="section() === 'comments'" [attr.aria-current]="section() === 'comments' ? 'page' : null"
         uiSref="profile.comments" [uiParams]="{ profileId: user.slug }">Comments</a>
      <a class="profile-page__tab" [class.is-active]="section() === 'mentions'" [attr.aria-current]="section() === 'mentions' ? 'page' : null"
         uiSref="profile.mentions" [uiParams]="{ profileId: user.slug }">Mentions</a>
      @if (isOwn()) {
        <a class="profile-page__tab" [class.is-active]="section() === 'likes'" [attr.aria-current]="section() === 'likes' ? 'page' : null"
           uiSref="profile.likes" [uiParams]="{ profileId: user.slug }">Likes</a>
      }
    </nav>
  }

  <div class="profile-page__body">
    <!-- Overview's cards have their own h2 headings; the lists get one for the tab. -->
    @if (section() !== 'overview') {
      <h2 class="sr-only">{{ sectionTitle() }}</h2>
    }
    @switch (section()) {
      @case ('overview') {
        <ut-community-profile-overview [user]="user"></ut-community-profile-overview>
      }
      @case ('posts') {
        <ut-community-profile-posts [user]="user" [me]="me()" [isOwn]="isOwn()" [segment]="$any(child())"></ut-community-profile-posts>
      }
      @case ('people') {
        <ut-community-profile-people [user]="user" [kind]="$any(child())" (followChange)="onFollowChange($event)"></ut-community-profile-people>
      }
      @default {
        @if (section() !== 'likes' || isOwn()) {
          <ut-community-profile-activity-list [user]="user" [isOwn]="isOwn()" [kind]="$any(section())"></ut-community-profile-activity-list>
        }
      }
    }
  </div>
</div>
